import { Injectable, inject } from '@angular/core';
import {catchError, Observable, shareReplay, throwError} from 'rxjs';
import {IdentityAdminService} from './identity-admin.service';
import {GrantableRolesResponse} from '../model/identity';

/**
 * Session cache for GET /company/v3/metadata/roles (ticket §4.1: "call once after sign-in,
 * cache for the session, refetch after refresh"). plan Q12.
 *
 * Memory only. First subscriber fetches; shareReplay(1) hands the same answer to everyone
 * after. A failed fetch is NOT cached, so the next caller retries. AuthService calls
 * invalidate() on every refresh-token response and on logout, because a promotion or demotion
 * rides in on the new token and the old grantable set would offer too much or too little.
 */
@Injectable({
  providedIn: 'root'
})
export class RoleMetadataService {
  private identityAdmin = inject(IdentityAdminService);

  private cache$: Observable<GrantableRolesResponse> | null = null

  roles$(): Observable<GrantableRolesResponse> {
    if (!this.cache$) {
      this.cache$ = this.identityAdmin.getGrantableRoles().pipe(
        catchError(err => {
          this.cache$ = null
          return throwError(() => err)
        }),
        shareReplay({bufferSize: 1, refCount: false})
      )
    }
    return this.cache$
  }

  invalidate(): void {
    this.cache$ = null
  }
}
